var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'cys-button',
    {
      'cys-button--plain': _vm.plain,
      'cys-button--circle': _vm.circle,
      'cys-button--no-slot': !_vm.$slots.default
    },
    'cys-button--' + _vm.stype
  ],on:{"click":_vm.handleClick}},[(_vm.leftIcon)?_c('i',{class:[
      'iconfont',
      ( _obj = {}, _obj[_vm.leftIcon] = _vm.leftIcon, _obj )
    ]}):_vm._e(),_vm._v(" "),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.rightIcon)?_c('i',{class:[
      'iconfont',
      ( _obj$1 = {}, _obj$1[_vm.rightIcon] = _vm.rightIcon, _obj$1 )
    ]}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-15d8405e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/cys-button.vue
// module id = null
// module chunks = 